import { render, staticRenderFns } from "./Owners.vue?vue&type=template&id=4e11d5fc&scoped=true"
import script from "./Owners.vue?vue&type=script&lang=ts"
export * from "./Owners.vue?vue&type=script&lang=ts"
import style0 from "./Owners.vue?vue&type=style&index=0&id=4e11d5fc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e11d5fc",
  null
  
)

export default component.exports